export const descendimiento = {
	nombre: "Descendimiento",
	dia: "Jueves Santo",
	nombrecompleto:
		"Real y Venerable Hermandad y Cofradía de Penitencia del Santísimo Cristo del Descendimiento de la Santa Cruz, María Santísima en su Quinta Angustia y Nuestra Señora de los Dolores",
	sede: "Parroquia de San Lorenzo Diácono y Mártir",
	pasos: 2,
	distancia: [1350, 1070],
	penitentes: 80,
	cargadores: 60,
	web:
		"http://www.diariodecadiz.es/semana_santa/Descendimiento_0_1229577730.html",

	ida: [
		{ lng: -6.3004138, lat: 36.5315968 },
		{ lng: -6.3003615, lat: 36.5315677 },
		{ lng: -6.3001536, lat: 36.5318608 },
		{ lng: -6.2995662, lat: 36.5315882 },
		{ lng: -6.2983297, lat: 36.5311388 },
		{ lng: -6.2976028, lat: 36.530933 },
		{ lng: -6.2975693, lat: 36.5310073 },
		{ lng: -6.2971777, lat: 36.5308812 },
		{ lng: -6.2966976, lat: 36.5308274 },
		{ lng: -6.2963093, lat: 36.5305897 },
		{ lng: -6.2956595, lat: 36.5299351 },
		{ lng: -6.2952706, lat: 36.5296754 },
		{ lng: -6.2945786, lat: 36.5295363 },
		{ lng: -6.2944928, lat: 36.5300019 },
		{ lng: -6.2943426, lat: 36.5305536 },
		{ lng: -6.2940958, lat: 36.530573 },
		{ lng: -6.2935071, lat: 36.5307336 },
		{ lng: -6.292921, lat: 36.5310741 },
		{ lng: -6.2921968, lat: 36.5302648 },
		{ lng: -6.2928191, lat: 36.5297928 },
		{ lng: -6.2930082, lat: 36.5298155 },
		{ lng: -6.2932751, lat: 36.5297346 },
		{ lng: -6.2938611, lat: 36.5297001 },
		{ lng: -6.2945293, lat: 36.529632 },
		{ lng: -6.2945545, lat: 36.5295073 },
		{ lng: -6.2950963, lat: 36.5296172 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.295689, lat: 36.5291074 },
		{ lng: -6.2954101, lat: 36.5298036 },
		{ lng: -6.2956595, lat: 36.5299652 },
		{ lng: -6.2952834, lat: 36.5303564 },
		{ lng: -6.2950212, lat: 36.5308327 },
		{ lng: -6.2949219, lat: 36.5308349 },
		{ lng: -6.2949219, lat: 36.5314524 },
		{ lng: -6.2964723, lat: 36.5317843 },
		{ lng: -6.2964106, lat: 36.5318662 },
		{ lng: -6.2967928, lat: 36.5325408 },
		{ lng: -6.2972595, lat: 36.5319168 },
		{ lng: -6.297356, lat: 36.5315321 },
		{ lng: -6.2975988, lat: 36.530892 },
		{ lng: -6.2982935, lat: 36.5310946 },
		{ lng: -6.299589, lat: 36.5315644 },
		{ lng: -6.3001496, lat: 36.5318274 },
		{ lng: -6.3003588, lat: 36.5315343 },
		{ lng: -6.3004285, lat: 36.5315623 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-29T23:00",
			latlng: [36.53158, -6.30041]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T01:30",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T02:30",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T03:30",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T03:55",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T04:05",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Sagasta (izq.)",
			"Hospital de Mujeres (drch)",
			"Plaza la Libertad",
			"Plaza Topete",
			"Compañía",
			"Plaza de Pío XII",
			"Cobos",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Barrié (Izq.)"],
		["Plaza Libertad", "Hospital de Mujeres", "Sagasta (Izq.)"]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/descendimiento.js